export default __webpack_public_path__ + "static/media/instagram.92ec91cf.svg";